import createAsyncSlice from "../utils/createAsyncSlice";

const warehouses = createAsyncSlice({
  name: "warehouses",
  initialState: {
    data: [],
  },
});

export const fetchWarehouses = warehouses.asyncAction;
export const { resetState: resetWarehousesState } = warehouses.actions;
export default warehouses.reducer;
